import { gql } from "@grandvisionhq/graphql";
import StoreFragment from "../../../fragments/operations/fragments/store.js";
import StoreInventoryFragment from "../../../fragments/operations/fragments/store-inventory.js";
import StoreOffersFragment from "../../../fragments/operations/fragments/store-offers.js";
import StoreReservabilityFragment from "../../../fragments/operations/fragments/store-reservability.js";
const GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY = gql`
  query GetStoresByDistance(
    $searchGeoLocation: GeoLocationInput!
    $deviceGeoLocation: GeoLocationInput
    $maxResults: Int
    $query: String
    $filter: StoreFilter
    $forceDistance: Boolean = false
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      deviceGeoLocation: $deviceGeoLocation
      maxResults: $maxResults
      query: $query
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...Store
    }
  }
  ${StoreFragment}
`;
const GET_STORES_BY_DISTANCE_WITH_INVENTORY = gql`
  query GetStoresByDistanceWithInventory(
    $searchGeoLocation: GeoLocationInput!
    $deviceGeoLocation: GeoLocationInput
    $maxResults: Int
    $query: String
    $filter: StoreFilter
    $forceDistance: Boolean = false
    $sku: ID!
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      deviceGeoLocation: $deviceGeoLocation
      maxResults: $maxResults
      query: $query
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...Store
      ...StoreInventory
      ...StoreReservability
      ...StoreOffers
    }
  }
  ${StoreFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
  ${StoreOffersFragment}
`;
export {
  GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY,
  GET_STORES_BY_DISTANCE_WITH_INVENTORY
};
//# sourceMappingURL=get-stores-by-distance.js.map
